import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const base_url = process.env.REACT_APP_API_URL;

export default function PendingWithdraw() {
  const token = localStorage.getItem("admin_token");

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  /* -------- Fetch Withdraws -------- */

  const fetchWithdraw = async () => {
    const res = await axios.get(`${base_url}/api/admin/withdraws`, {
      headers: { Authorization: token },
    });

    if (res.data.success) {
      setData(res.data.data);
    }
  };

  useEffect(() => {
    fetchWithdraw();
  }, []);

  /* -------- Confirm Withdraw -------- */

  const confirmWithdraw = async (item) => {
    const { value: file } = await Swal.fire({
      title: "Upload Payment Proof",
      input: "file",
      inputLabel: "Upload payment screenshot",
      inputAttributes: {
        accept: "image/*",
      },
      showCancelButton: true,
      confirmButtonText: "Confirm",
      inputValidator: (value) => {
        if (!value) {
          return "Payment proof is required!";
        }
      },
    });

    if (!file) return;

    const formData = new FormData();
    formData.append("id", item.id);
    formData.append("status", 1);
    formData.append("proof", file);

    try {
      const res = await axios.post(
        `${base_url}/api/admin/update-withdraw-status`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data.success) {
        toast.success("Withdraw confirmed");
        fetchWithdraw();
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  /* -------- Reject Withdraw -------- */

  const rejectWithdraw = async (item) => {
    const { value: remark } = await Swal.fire({
      title: "Reject Withdraw",
      input: "text",
      inputLabel: "Remark (required)",
      showCancelButton: true,
      confirmButtonText: "Reject",
      inputValidator: (value) => {
        if (!value) {
          return "Remark required!";
        }
      },
    });

    if (!remark) return;

    try {
      const res = await axios.post(
        `${base_url}/api/admin/update-withdraw-status`,
        {
          id: item.id,
          status: 2,
          remark,
        },
        { headers: { Authorization: token } },
      );

      if (res.data.success) {
        toast.success("Withdraw rejected");
        fetchWithdraw();
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* -------- Search -------- */
  const filtered = data.filter((item) => item.phone?.includes(search));

  const copyDetails = (item) => {
    let text = "";

    if (item.method === "bank") {
      text = `Bank: ${item.bank_name}
Name: ${item.holder_name}
Account: ${item.account_no}
IFSC: ${item.ifsc}`;
    }

    if (item.method === "upi") {
      text = `UPI ID: ${item.upi_id}`;
    }

    if (item.method === "usdt") {
      text = `USDT Address: ${item.usdt_address}`;
    }

    navigator.clipboard.writeText(text);

    toast.success("Details copied");
  };

  return (
    <div className="px-3 px-md-4">
      <div className="d-flex justify-content-between mb-3 flex-wrap">
        <h4>Withdraw Requests</h4>

        <input
          className="form-control w-auto"
          placeholder="Search phone"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Phone</th>
                <th>Amount</th>
                <th>Method</th>
                <th>Details</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.length > 0 ? (
                filtered.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.phone}</td>

                    <td className="fw-bold text-danger">₹{item.amount}</td>

                    <td>{item.method}</td>

                    <td>
                      {/* BANK */}
                      {item.method === "bank" && (
                        <div style={{ fontSize: "13px" }}>
                          <div>
                            <b>Bank:</b> {item.bank_name}
                          </div>
                          <div>
                            <b>Name:</b> {item.holder_name}
                          </div>
                          <div>
                            <b>Acc:</b> {item.account_no}
                          </div>
                          <div>
                            <b>IFSC:</b> {item.ifsc}
                          </div>
                        </div>
                      )}

                      {/* UPI */}
                      {item.method === "upi" && (
                        <div style={{ fontSize: "13px" }}>
                          <div>
                            <b>UPI:</b> {item.upi_id}
                          </div>

                          {item.upi_qr && (
                            <img
                              src={`${base_url}/uploads/${item.upi_qr}`}
                              alt="QR"
                              width="40"
                              style={{
                                cursor: "pointer",
                                marginTop: "4px",
                                borderRadius: "4px",
                              }}
                              onClick={() =>
                                Swal.fire({
                                  imageUrl: `${base_url}/uploads/${item.upi_qr}`,
                                  imageWidth: 300,
                                  showConfirmButton: false,
                                })
                              }
                            />
                          )}
                        </div>
                      )}

                      {/* USDT */}
                      {item.method === "usdt" && (
                        <div style={{ fontSize: "13px" }}>
                          <b>USDT:</b> {item.usdt_address}
                        </div>
                      )}
                    </td>

                    <td>
                      <span className="badge bg-warning">Pending</span>
                    </td>

                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => copyDetails(item)}
                          title="Copy details"
                        >
                          📋
                        </button>

                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => confirmWithdraw(item)}
                        >
                          Confirm
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => rejectWithdraw(item)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No withdraw requests
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
